import React from 'react';
import { LogOut, X } from 'lucide-react';

interface LogoutDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  isDecline?: boolean;
}

const LogoutDialog: React.FC<LogoutDialogProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  isLoading = false,
  isDecline = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-engramiq-dark-blue border border-engramiq-green/20 rounded-lg p-6 max-w-md w-full mx-4 shadow-xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <h3 className="text-lg font-semibold text-engramiq-light-grey">
              {isDecline ? 'Decline Invitation' : 'Sign Out'}
            </h3>
          </div>
          <button
            onClick={onClose}
            disabled={isLoading}
            className="text-engramiq-bright-grey hover:text-engramiq-light-grey transition-colors disabled:opacity-50"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-engramiq-bright-grey">
            {isDecline 
              ? 'Are you sure you want to decline this invitation? This action cannot be undone.'
              : "Are you sure you want to sign out? You'll need to sign in again to access your account."}
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-5 py-2 bg-surface-800 border border-engramiq-green/30 hover:border-engramiq-green rounded-lg text-engramiq-light-grey transition-all disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-5 py-2 bg-accent-red hover:bg-accent-red/80 border border-accent-red rounded-lg text-white transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <div className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                {isDecline ? 'Declining...' : 'Signing out...'}
              </>
            ) : (
              <>
                {isDecline ? 'Decline' : 'Logout'}
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutDialog;
